import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'i18n';
import { mediaQueries } from 'styles/utils/mediaQueries';
import DealCard from './dealCard/DealCardComponent';

function DealsCardsComponent({ deals, pathToDealPage }) {
  return (
    <Root>
      <Title>
        <FormattedMessage id={'hotDeals.header.label'} description={'Hot deals'} defaultMessage={'Hot deals'} />
      </Title>
      <Subheader>
        <FormattedMessage
          id={'hotDeals.subheader.message'}
          description={'hot delas subheader'}
          defaultMessage={
            'Here you will find unusually affordable travel options. Often, the hotels or airlines have given high discounts due to poor booking conditions for a shorter period. Under the heading of hot deals we have selected some of these as inspiration for you. Choose one of them, or look for yourself.'
          }
        />
      </Subheader>
      {deals.map((deal, index) => (
        <DealCard key={`deal-${index}`} deal={deal} pathToDealPage={pathToDealPage} />
      ))}
    </Root>
  );
}

export default DealsCardsComponent;

const Root = styled.div`
  max-width: 1024px;
  margin: 0 auto;
  padding: 40px 15px;
  display: flex;
  flex-direction: column;
`;

const Title = styled.h1`
  width: 100%;
  margin-top: 130px;
  margin-bottom: 35px;
  font-size: 72px;
  font-weight: bold;
  text-align: center;
  color: ${({ theme }) => theme.colors.text.templates.header};
`;

const Subheader = styled.div`
  max-width: 760px;
  margin: 0 auto 60px;
  font-size: 1.6em;
  color: ${({ theme }) => theme.colors.text.default};
  text-align: center;

  ${mediaQueries.fromAndBelow.tablet`
    margin: 0 15px 32px;
    text-align: justify;
  `}
`;
